// WCAG: high-contrast toggle. Pairs with the conditionally-disabled <link id="a11y">
// in base.html (server-rendered from the "a11y" cookie via view/base.py's
// template_data()) and the override rules in src/css/a11y.scss.
const contrast_btn = document.getElementById('contrast-btn');

if (contrast_btn) {
    contrast_btn.addEventListener('click', toggleContrast);

    window.addEventListener('oilib_loaded', () => {
        setContrastState(!!oi.utils.cookie.val('a11y'));
    });
}

function toggleContrast() {
    const stylesheet = document.getElementById('a11y');
    const enabling = stylesheet.disabled;

    if (enabling) {
        oi.utils.cookie.set('a11y', 'true');
    } else {
        oi.utils.cookie.delete('a11y');
    }
    setContrastState(enabling);
}

function setContrastState(enabled) {
    const stylesheet = document.getElementById('a11y');
    stylesheet.disabled = !enabled;
    contrast_btn.setAttribute('aria-pressed', String(enabled));
    contrast_btn.classList.toggle('border-active', enabled);
    contrast_btn.innerHTML = `High Contrast <span class="btn-state">${enabled ? 'ON' : 'OFF'}</span>`;
}

// Focus rings only need to be visible for keyboard users, not mouse clicks -- flag the
// first Tab press so src/css/a11y.scss's `body.accessible` rule can key off it.
function flagKeyboardUser(e) {
    if (e.key === 'Tab') {
        document.body.classList.add('accessible');
        window.removeEventListener('keydown', flagKeyboardUser);
    }
}
window.addEventListener('keydown', flagKeyboardUser);
